<div class="container">
    <div class="row">
        <div class="col">
            <div class="jumbotron w-100">
                <h1 class="text-capitalize">Calendario</h1>
                <p>Ci sono {{ get().length }} eventi a calendario</p>
                <p>Ci sono {{ get('sent').length }} richieste inviate</p>
                <p>Ci sono {{ get('received').length }} richieste ricevute</p>
            </div>
        </div>
    </div>

    <div class="row mt-5">
        <div class="col">
            
            <div class="calendar">
                <header>
                    <h2>{{ getMonth() }}</h2>
                    <a class="btn-prev fontawesome-angle-left" 
                    [routerLink]="'/calendar'" 
                    [queryParams]="changeQueryParam({'calendar': getCurrent().add(-1, 'month').valueOf() })">&#8592;</a>

                    <a class="btn-next fontawesome-angle-right" 
                    [routerLink]="'/calendar'" 
                    [queryParams]="changeQueryParam({'calendar': getCurrent().add(1, 'month').valueOf() })">&#8594;</a>
                </header>
                <table class="calendar-table">
                    <thead>
                        <tr>
                            <td>Lun</td>
                            <td>Mar</td>
                            <td>Mer</td>
                            <td>Gio</td>
                            <td>Ven</td>
                            <td>Sab</td>
                            <td>Dom</td>
                        </tr>
                    </thead>

                    <tbody>
                        <tr *ngFor="let week of getCurrentMonth(); index as i">
                            <td *ngFor="let day of week; index as i"
                            (click)="!!day.number && setCurrentDay(day.day)" 
                            [ngClass]="getCellClass(day)">
                                {{ day.number || '' }}
                            </td>
                        </tr>
                    </tbody>

                </table>
            </div>
        </div>
    </div>

    <div class="row mt-5 mb-5" [hidden]="!queryparams()['calendar'] || !get('current_events').length">
        <div class="col">

            <div class="table-responsive-md mt-2">
                <table class="table">
                    <thead class="thead-primary">
                        <tr>
                            <th scope="col">ID</th>
                            <th scope="col">Nome</th>
                            <th scope="col">Inizio</th>
                            <th scope="col">Fine</th>
                            <th scope="col">Target</th>
                        </tr>
                    </thead>
                    <tbody>
                        <a class="table-row" 
                            *ngFor="let event of get('current_events'); index as i" 
                            ><!--[routerLink]="'/organizer'" 
                            [queryParams]="changeQueryParam({'rule-selected': rule.id})"-->
                            <td scope="col">{{ event.public_token.substr(0, 5) }}</td>
                            <td scope="col">{{ event.name || '' }}</td>
                            <td scope="col">{{ (""+event.start_timestamp.getHours() || '00').padStart(2, "0") + ":" + (""+event.start_timestamp.getMinutes() || '00').padStart(2, "0") }}</td>
                            <td scope="col">{{ (""+event.end_timestamp.getHours() || '00').padStart(2, "0") + ":" + (""+event.end_timestamp.getMinutes() || '00').padStart(2, "0") }}</td>
                            <td scope="col">{{ getTarget(event) }}</td>
                        </a>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>